/* globals route axios */

class Authorization {

  constructor() {
    this.authorized = {};
    this.registered = [];
  }

  /**
   * Register a new authorization.
   *
   * @param {*} authorization
   */
  register(authorization) {
    const authorizations = typeof authorization === 'string' ? Array.of(authorization) : authorization;

    authorizations.forEach((auth) => {
      if (this.registered.indexOf(auth) === -1) {
        this.registered.push(auth);
      }
    });

    this.fetch();
  }

  /**
   * Fetch the authorizations.
   */
  fetch() {
    if (this.getMissing().length) {
      axios.post(route('authorization'), {
        authorize: this.getMissing(),
      }).then(({ data }) => {
        this.authorized = { ...this.authorized, ...data };
      });
    }
  }

  /**
   * Clear the authorizations.
   */
  clear() {
    this.registered = [];
    this.authorized = {};
  }

  /**
   * Is the given authorization allowed ?
   *
   * @param {*} authorization
   */
  can(authorization) {
    if (Object.keys(this.authorized).indexOf(authorization) === -1) {
      return false;
    }

    return this.authorized[authorization];
  }

  /**
   * Is the given authorization not allowed ?
   *
   * @param {*} authorization
   */
  cannot(authorization) {
    return !this.can(authorization);
  }

  /**
   * Get the missing authorizations.
   */
  getMissing() {
    return this.registered.filter(
      auth => !Object.prototype.hasOwnProperty.call(this.authorized, auth),
    );
  }

}

export default Authorization;
